/**
 * Restores scroll position on navigation within the Knowledge Center.
 *
 * React Router's `<Routes>` (without a data router) does no scroll
 * restoration, so navigating between articles swaps the DOM and leaves the
 * viewport where it was. That is especially bad here because the Prev/Next
 * cards sit at the *bottom* of an article — the one affordance for moving on
 * is only reachable from the exact scroll position that breaks the landing.
 *
 * Hash links are the deliberate exception: the on-this-page TOC and the top
 * bar's "FAQs" link both navigate to a fragment, so when there is a hash we
 * scroll to that element instead of to the top.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // The element may mount in the same commit as this effect; look it up
      // now and fall through to the top only if it genuinely is not there.
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (target) {
        target.scrollIntoView();
        return;
      }
    }

    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;
